import { DefaultSelectable } from "../menu/interfaces";
import { TextContent } from "./text-content";
import getDecorators from "inversify-inject-decorators";
import container from "../../ioc/inversify.config";
import TYPES from "../../ioc/types";
import { ThemeManager } from "../design-system/theme-manager";

const { lazyInject } = getDecorators(container);

export enum IconPosition {
    LEFT = "left",
    RIGHT = "right",
    TOP = "top",
    BOTTOM = "bottom",
}

export class TextAndIcon extends DefaultSelectable {
    @lazyInject(TYPES.ThemeManager)
    private themeManager: ThemeManager;

    private text: TextContent;
    private sprite: Phaser.GameObjects.Sprite;

    constructor(
        x: number,
        y: number,
        text: string,
        path: string,
        frame: number | string,
        iconPosition: IconPosition,
        scene: Phaser.Scene
    ) {
        super(scene, x, y);

        const spacing = this.themeManager.getComponentSpacing("gapSmall");

        // Build the icon sprite
        this.sprite = this.buildIcon(path, frame);

        if (!this.sprite) {
            // If sprite failed to build, just create text at origin
            this.text = new TextContent(0, 0, text, scene);
            this.add(this.text);
            return;
        }

        // Position text and sprite based on IconPosition
        this.positionElements(text, iconPosition, spacing, scene);
    }

    private positionElements(
        text: string,
        position: IconPosition,
        spacing: number,
        scene: Phaser.Scene
    ) {
        let textX = 0;
        let textY = 0;
        let spriteX = 0;
        let spriteY = 0;

        // Create text first to get its height for vertical centering
        this.text = new TextContent(0, 0, text, scene);
        this.text.setOrigin(0, 0);

        switch (position) {
            case IconPosition.LEFT:
                // Icon on left, text on right, vertically centered
                spriteX = 0;
                spriteY = 0;
                textX = this.sprite.width + spacing;
                // Center text vertically with icon
                textY = (this.sprite.height - this.text.height) / 2;
                break;

            case IconPosition.RIGHT:
                // Text on left, icon on right, vertically centered
                textX = 0;
                textY = 0;
                spriteX = this.text.width + spacing;
                // Center icon vertically with text
                spriteY = (this.text.height - this.sprite.height) / 2;
                break;

            case IconPosition.TOP:
                // Icon on top, text below
                spriteX = 0;
                spriteY = 0;
                textX = 0;
                textY = this.sprite.height + spacing;
                break;

            case IconPosition.BOTTOM:
                // Text on top, icon below
                textX = 0;
                textY = 0;
                spriteX = 0;
                spriteY = this.text.height + spacing;
                break;
        }

        // Position sprite and text
        this.sprite.setPosition(spriteX, spriteY);
        this.text.setPosition(textX, textY);

        // Add to container
        this.add(this.sprite);
        this.add(this.text);
    }

    private buildIcon(path: string, frame: number | string): Phaser.GameObjects.Sprite {
        if (!path || !frame) {
            console.log("missing data to build sprite");
            return null;
        }
        const itemSprite = this.scene.add.sprite(0, 0, path, frame);
        itemSprite.setOrigin(0, 0);
        return itemSprite;
    }
}
